import { render } from "./BorderLine.vue?vue&type=template&id=3aef615e"
import script from "./BorderLine.vue?vue&type=script&lang=js"
export * from "./BorderLine.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__